<template>
  <div class="mt-15 wrapperImage">
    <div class="buttons">
      <div 
        v-for="button in buttons"
        :key="button.id"
        >
        <router-link
          :to="button.url ? button.url : ''"
          @click="button.action ? toPlicante() : button.id == 5 ? openModal() : '' " 
          class="btn"
          v-if="
            (button.action == 'toPlicante' && 
            (getUserData?.roles?.includes('Administrator') || 
            getUserData?.roles?.includes('ApkEmployer'))) || 
            (button.url == '/roles' && getUserData?.roles?.includes('Administrator')) ||
            (button?.id == '5' && (getUserData?.roles?.includes('OmsuDirector') || getUserData?.roles?.includes('OmsuSpecialist')))
            "
        >
          <v-icon class="icon mt-5" style="font-size: 62px;">{{ button.icon }}</v-icon>
          <p :class="`mb-${button.mb}`">{{ button.name }}</p>
        </router-link>
      </div>
    </div>
  </div>
  <SummaryReportModal
  v-model="reportModal"
/>
</template>

<script>
import { mapGetters } from 'vuex';
import SummaryReportModal from '../SummaryReportModal.vue'

export default {
  components: {
    SummaryReportModal
  },
  data() {
    return {
      reportModal: false,
      buttons: [
        // { id: 1, name: 'Журнал "Парк сельскохозяйственной техники"', url: '/table/6248', icon: 'mdi-tractor', mb: 4 },
        // { id: 2, name: 'Отчеты по технике', url: '/table/3297', icon: 'mdi-file-document-edit', mb: 10 },
        { id: 3, name: 'Web ВИИС', action: "toPlicante", icon: 'mdi-align-horizontal-left',  mb: 15},
        { id: 4, name: 'Taблица ролей', url: '/roles', icon: 'mdi-account-details',  mb: 15},
        { id: 5, name: 'Сводный отчет по растениеводству', icon: 'mdi-account-details',  mb: 15}
      ]
    };
  },
  methods: {
    toPlicante() {
      // window.location.href = `http://localhost:8081/?aistoken=Bearer ${localStorage.getItem('token')}`
      window.location.href = `https://apk-plicante.lenobl.ru/?aistoken=Bearer ${localStorage.getItem('token')}`
    },
    openModal() {
      this.reportModal = true
    }
  },
  computed: {
    ...mapGetters(['getUserData'])
  },
  mounted() {
    // this.getToken()
  }
};
</script>

<style scoped>
.wrapperImage {
  width: 100%;
  height: calc(100vh - 58px);
  background-image:
    linear-gradient(var(--app-home-overlay), var(--app-home-overlay)),
    url('@/assets/bg_home.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons {
  display: flex;
  gap: 20px;
}

.buttons p {
  text-align: center
}

.btn {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  font-size: 16px;
  text-decoration: none;
  color: var(--app-text);
  border-radius: 20px;
  border: 1px solid var(--app-border);
  background: color-mix(in srgb, var(--app-surface) 82%, transparent);
  box-shadow: 0 10px 30px var(--app-shadow);
  backdrop-filter: blur(8px);
  transition: background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.btn:hover {
  background: color-mix(in srgb, var(--app-surface-elevated) 92%, transparent);
  border-color: var(--app-primary);
  transform: translateY(-2px);
}

@media (max-width: 480px) {
  .wrapperImage {
    height: auto;
    min-height: calc(100svh - 60px);
    padding: 20px 12px;
    align-items: flex-start;
    box-sizing: border-box;
  }

  .buttons {
    width: 100%;
    max-width: 376px;
    flex-direction: column;
    gap: 12px;
  }

  .buttons > div {
    width: 100%;
  }

  .buttons > div:empty {
    display: none;
  }

  .btn {
    width: 100%;
    min-height: 96px;
    height: auto;
    padding: 14px 16px;
    box-sizing: border-box;
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
    border-radius: 14px;
  }

  .btn .icon {
    margin-top: 0 !important;
    flex: 0 0 auto;
    font-size: 42px !important;
  }

  .btn p {
    margin-bottom: 0 !important;
    text-align: left;
    overflow-wrap: anywhere;
  }
}
</style>
